export const initZoro = (num: number, len: number) => {
    let size = len - String(num).length
    size = size > 0 ? size : 0
    let zeros = Array(size).fill(0).join("")
    return zeros + String(num)
}